import Reflux from "reflux";

const AppActions = Reflux.createActions([
  "initialize",
  "initializeFinished",
  "requireLogin",
  "restart",
  "showSaveError",
  "showAppError",
  "storeValue",
  "checkAppStatus",
]);

export default AppActions;
